import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubIcon } from "../../components";

const ThroughputWorkOrdersEmpty = ({
  title = "No Work Orders",
  subtitle = "There are no work orders for this customer in the selected range.",
}) => (
  <Stack
    gap="10px"
    alignItems="center"
    justifyContent="center"
    padding="30px"
    minHeight="300px"
    sx={{
      border: "1px dashed",
      borderColor: "hubColors.greyLight",
      borderRadius: "6px",
    }}
  >
    <HubIcon icon="FileText" size="20px" sx={{ color: "hubColors.grey" }} />
    <Stack alignItems="center" justifyContent="center">
      <Typography variant="boldCaption" fontSize={12}>
        {title}
      </Typography>
      <Typography
        variant="caption"
        fontSize={11}
        textAlign="center"
        maxWidth="320px"
      >
        {subtitle}
      </Typography>
    </Stack>
  </Stack>
);

export default ThroughputWorkOrdersEmpty;
